import { IFilterCompaniaModel } from "../interfaces/compania/IFilterCompaniaModel";

export class FilterCompaniaModel implements IFilterCompaniaModel {
    idCompania: number[];
    compania:string;
    nombre: string;
    page: number;
    pageSize: number;
    constructor(){
        this.idCompania = new Array<number>();
        this.compania='';
        this.nombre='';
        this.page = 1;
        this.pageSize = 30;
    }
}
